import { useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import Seo from "@/components/common/Seo";

export default function Feedback() {
  const [fb, setFb] = useState({ name: "", email: "", message: "" });
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!fb.message.trim()) return;
    setSending(true);
    try {
      await api.post("/feedback", { name: fb.name || null, email: fb.email || null, message: fb.message.trim() });
      setSent(true);
    } catch {
      toast.error("Could not send your feedback. Please try again.");
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="max-w-xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
      <Seo title="Send Feedback — Transplant Story" description="Share feedback, corrections or suggestions with the Transplant Story team." />
      <div className="text-[11px] font-mono uppercase tracking-widest text-rust mb-4">Feedback</div>
      <h1 className="text-4xl sm:text-5xl font-light tracking-tight text-ink">Give us feedback</h1>
      <p className="text-base text-neutral-500 mt-5 leading-relaxed">
        Spotted something wrong, or have a suggestion? Tell us — we read every message.
      </p>

      {sent ? (
        <div data-testid="feedback-success" className="mt-10 border border-neutral-200 bg-[#FAF8F5] p-6">
          <p className="text-ink font-medium">Thank you — your feedback has been received.</p>
          <p className="text-sm text-neutral-500 mt-2">We review every message and will act on it soon.</p>
        </div>
      ) : (
        <form onSubmit={submit} className="mt-10 space-y-4">
          <div className="grid sm:grid-cols-2 gap-4">
            <input
              data-testid="feedback-name"
              value={fb.name}
              onChange={(e) => setFb({ ...fb, name: e.target.value })}
              placeholder="Name (optional)"
              className="border border-neutral-300 px-4 py-3 bg-white outline-none focus:border-rust transition-colors"
            />
            <input
              data-testid="feedback-email"
              type="email"
              value={fb.email}
              onChange={(e) => setFb({ ...fb, email: e.target.value })}
              placeholder="Email (optional)"
              className="border border-neutral-300 px-4 py-3 bg-white outline-none focus:border-rust transition-colors"
            />
          </div>
          <textarea
            data-testid="feedback-message"
            required
            rows={6}
            value={fb.message}
            onChange={(e) => setFb({ ...fb, message: e.target.value })}
            placeholder="Your feedback…"
            className="w-full border border-neutral-300 p-4 bg-white outline-none focus:border-rust transition-colors resize-none"
          />
          <button
            data-testid="feedback-submit"
            type="submit"
            disabled={sending || !fb.message.trim()}
            className="bg-ink text-white px-7 py-3 text-sm font-medium hover:bg-rust transition-colors disabled:opacity-30"
          >
            {sending ? "Sending…" : "Send feedback"}
          </button>
        </form>
      )}
    </div>
  );
}
